var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"base-icon",attrs:{"width":_vm.size,"height":_vm.size,"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","aria-hidden":"true","focusable":"false"}},[_c('g',{attrs:{"fill":_vm.iconFill === 'fill' ? _vm.textColor : 'transparent',"stroke":_vm.iconFill === 'stroke' ? _vm.textColor : 'transparent'}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }